import gettext from '@sdk/lang/gettext';
import SlingTip from '@sdk/common/slingTip/SlingTip';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { IntegrationType } from '@sdk/integrations/types';
import useAuth from '@sdk/authentication/useAuth';

type Props = {
  toastIntegration: IntegrationType;
};

export const ToastTips = ({ toastIntegration }: Props) => {
  const { currentUser } = useAuth();

  if (!toastIntegration.enabled && currentUser.org.toastSubscription === 'pro') {
    return (
      <SlingTip isVisible={true}>
        <Text14 semiBold themeColor={ThemeColorType.white}>
          {gettext('Your Scheduling Pro has been disconnected.')}
          <br />
          {gettext('Reconnect to Toast to continue using Pro subscription.')}
        </Text14>
      </SlingTip>
    );
  }
};
